export default __webpack_public_path__ + "static/traefik-mesh-logo-bbc60145bad48681b9be893b91c73d6f.svg";